import { defineComponent } from 'vue';
import SupplierComponent from '@/components/SupplierComponent.vue';
export default defineComponent({
    name: 'Supplier',
    components: { SupplierComponent },
    data() {
        return {};
    }
});
